<div class="card">
	<div class="card-header">
		<h1>Fechas DTE</h1>
	</div>
	<div class="form-group">
		<label for="search" class="form-label">Buscar empresa</label>
		<input type="text" [(ngModel)]="filterWord" (input)="filterCompany()" autocomplete="off"
			placeholder="Ingresa nombre de empresa" id="search" name="search" class="form-control">
	</div>
	<div class="grid-companies">
		<ng-container *ngFor="let company of companiesDateDte">
			<div class="card">
				<div class="card-header">
					<h5>{{company.name}}</h5>
				</div>
				<div class="card-body">
					<div class="row">
						<div class="col-sm-4">
							<img src="{{company.logo!=null ? 'https://s3.amazonaws.com/rrhh-images/company/logos/' + company.logo : ''}}"
								alt="" (error)="$event.target.src = '../../../../../assets/img/nophoto.svg'">
						</div>
						<div class="col-sm-8">
							<b>{{company.nit}} - {{company.alphanumericId}}</b>
                            <ng-container>
                                <div class="input-group">
                                    <input type="date" [ngModel] ="company.dateDte | date:'yyyy-MM-dd'" (ngModelChange)="company.dateDte = $event" id="dateDte" name="dateDte" class="form-control">
                                    <button class="btn btn-primary input-group-text" (click)="saveDateDte(company)">
                                        <i class="fa fa-edit" style="color: white;"></i>
                                    </button>
                                </div>
                            </ng-container>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
	<span class="display-5 text-info" style="text-align: center; padding: 2em;" *ngIf="companiesDateDte.length == 0"><i
			class="fa fa-circle-plus"></i>No se encontraron compañias con fechas guardadas</span>
	<app-simple-pagination style="z-index: -1 !important;" [elements]="pagination" [sizes]="sizes"
		(changed)="getPaginationCompaniesDateDte()"></app-simple-pagination>
</div>